import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';

interface Commit { hash: string; subject: string; date: string; author?: string; }

/**
 * Commit-hash footer + changelog overlay, from the same /api/changelog source as the
 * main dashboard footer. Shared so Claudia (and anything else) can show the deployed
 * commit with a click-through changelog.
 */
@Component({
  selector: 'app-commit-bar',
  template: `
    <div class="commit-bar">
      <code (click)="open = true" title="Changelog">{{ shortHash }}</code>
    </div>

    <div class="cl-overlay" [class.open]="open" (click)="onBackdrop($event)">
      <div class="cl-card">
        <div class="cl-head"><span>Changelog</span>
          <button class="cl-close" aria-label="close" (click)="open = false">✕</button></div>
        <div class="cl-body">
          <div *ngIf="!commits.length" class="cl-meta">—</div>
          <div class="cl-row" *ngFor="let c of commits">
            <div class="cl-meta">{{ c.date }} · {{ (c.hash || '').slice(0, 7) }}</div>
            <div class="cl-subj">{{ c.subject }}</div>
          </div>
        </div>
      </div>
    </div>
  `,
  styles: [`
    .commit-bar { text-align: center; padding: 6px; font-size: 0.7rem; color: var(--cb-muted, #8888aa); }
    .commit-bar code { color: var(--cb-muted, #8888aa); cursor: pointer; }
    .commit-bar code:hover { color: var(--cb-primary, #6c63ff); }
    .cl-overlay { position: fixed; inset: 0; z-index: 1090; display: none;
      align-items: center; justify-content: center; background: rgba(0,0,0,0.6); }
    .cl-overlay.open { display: flex; }
    .cl-card { background: var(--cb-surface, #1a1a2e); border: 1px solid var(--cb-border, #2a2a44);
      border-radius: 12px; width: min(94vw, 560px); max-height: 80vh; display: flex;
      flex-direction: column; overflow: hidden; color: var(--cb-text, #e8e8f0); }
    .cl-head { display: flex; align-items: center; justify-content: space-between;
      padding: 12px 16px; border-bottom: 1px solid var(--cb-border, #2a2a44); font-weight: 600; }
    .cl-close { background: none; border: 1px solid var(--cb-border, #2a2a44); color: inherit;
      border-radius: 8px; padding: 2px 10px; cursor: pointer; }
    .cl-body { overflow-y: auto; padding: 8px 16px; }
    .cl-row { padding: 8px 0; border-bottom: 1px solid var(--cb-border, #2a2a44); }
    .cl-meta { font-size: 0.7rem; color: var(--cb-muted, #8888aa); }
    .cl-subj { font-size: 0.85rem; }
  `],
})
export class CommitBarComponent implements OnInit {
  commits: Commit[] = [];
  shortHash = '…';
  open = false;

  constructor(private http: HttpClient) {}

  ngOnInit(): void {
    this.http.get<Commit[]>('/api/changelog').subscribe({
      next: (d) => {
        this.commits = Array.isArray(d) ? d : [];
        this.shortHash = this.commits[0]?.hash ? this.commits[0].hash.slice(0, 7) : 'dev';
      },
      error: () => { this.shortHash = 'dev'; },
    });
  }

  onBackdrop(e: MouseEvent): void {
    if ((e.target as HTMLElement).classList.contains('cl-overlay')) this.open = false;
  }
}
